const isMaliciousUrl = (url) => url.toLowerCase().trim().startsWith("data:");
export {
  isMaliciousUrl
};
//# sourceMappingURL=is-malicious-url.js.map
